import { Link } from 'react-router-dom';

interface Shortcut {
  label: string;
  description: string;
  icon: string;
  to: string;
  tone: 'primary' | 'accent' | 'secondary';
}

const shortcuts: Shortcut[] = [
  {
    label: '全部影片',
    description: '按类型与年份快速查找',
    icon: 'ri-film-line',
    to: '/category',
    tone: 'primary',
  },
  {
    label: '电影',
    description: '院线级故事与类型佳作',
    icon: 'ri-movie-line',
    to: '/category?type=movie',
    tone: 'secondary',
  },
  {
    label: '电视剧',
    description: '长线叙事与人物群像',
    icon: 'ri-tv-2-line',
    to: '/category?type=tv',
    tone: 'secondary',
  },
  {
    label: '热门推荐',
    description: '近期讨论度最高的作品',
    icon: 'ri-fire-line',
    to: '/category?tag=hot',
    tone: 'accent',
  },
  {
    label: '一周新片',
    description: '刚刚上线的新鲜片单',
    icon: 'ri-calendar-check-line',
    to: '/category?tag=new',
    tone: 'accent',
  },
];

const toneClasses: Record<Shortcut['tone'], string> = {
  primary: 'bg-primary-50 text-primary-700',
  accent: 'bg-accent-50 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 pt-8 md:pt-12">
      <div className="flex items-end justify-between gap-4 mb-4 md:mb-5">
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground-950">分类快捷入口</h2>
          <p className="mt-1 text-xs md:text-sm text-foreground-500">选一个方向，开始今晚的观影计划</p>
        </div>
        <Link
          to="/category"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {shortcuts.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            className="group flex items-start gap-3 p-3.5 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-background-100/70 transition-colors"
          >
            <span
              className={`w-10 h-10 md:w-11 md:h-11 shrink-0 rounded-lg flex items-center justify-center ${toneClasses[item.tone]}`}
            >
              <i className={`${item.icon} text-lg md:text-xl`} aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-foreground-950 group-hover:text-primary-700 transition-colors">
                {item.label}
              </span>
              <span className="mt-0.5 block text-[11px] md:text-xs text-foreground-500 leading-snug">
                {item.description}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}